<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Layout Filmstrip" class="d-icon d-icon--layout-filmstrip" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M2.5 10a.5.5 0 0 1-.5-.5V5h8v4.5a.5.5 0 0 1-.5.5h-7Zm8.5-.5A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7ZM10 4H8V2h1.5a.5.5 0 0 1 .5.5V4ZM7 2v2H5V2h2ZM4 2v2H2V2.5a.5.5 0 0 1 .5-.5H4Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLayoutFilmstrip',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
